import { OktaAuth } from '@okta/okta-auth-js';
import axios from 'axios';
import Util from '../Util';
import { FieldMetadata } from '../wizard/DataSettings';
import { MappingItemProps } from '../wizard/MappingItem';
import { OrgInfo } from './Backend';

class DataSettingsApi {
    baseUrl = window.REACT_APP_CONFIG?.REACT_APP_API_SERVER as string || process.env.REACT_APP_API_SERVER || '';
    controllerBaseUrl = `${this.baseUrl}/sfdc/`;
    currentTenant =
        Util.getSessionCurrentTenantInfo() && Util.getSessionCurrentTenantInfo().id
            ? Util.getSessionCurrentTenantInfo()
            : Util.getCurrentTenantInfo();

    headers = (okta: OktaAuth) => ({
        Authorization: `Bearer ${okta.getAccessToken()}`,
        'X-Tenant': this.currentTenant.id,
    });

    getMappingItems = async (okta: OktaAuth, access_token: string, instance_url: string, org_info?: OrgInfo) => {
        const req = { access_token, instance_url, org_info };

        const res = await axios.post<MappingItemProps[]>(`${this.controllerBaseUrl}template/get`, req, {
            headers: this.headers(okta),
        });

        return res.data;
    };

    getDataSettingItems = async (okta: OktaAuth, mapping_config_id?: string, parent_config_id?: string) => {
        const dataSettingsUrl = `${this.baseUrl}/config/dp_config`;
        const paramUrl =
            mapping_config_id && parent_config_id
                ? `?mapping_config_id=${mapping_config_id}&parent_config_id=${parent_config_id}`
                : '';
        const res = await axios.get(dataSettingsUrl + paramUrl, { headers: this.headers(okta) });

        return res.data;
    };

    updateDataSettings = async (
        okta: OktaAuth,
        parent_config_id: string,
        data_processing_config_id: string,
        data_setting: any,
        environment_id: string,
    ) => {
        const dataSettingsUrl = `${this.baseUrl}/config/dp_config/update`;
        const req = {
            parent_config_id,
            environment_id,
            data_processing_config_id,
            data_processing_config: data_setting,
        };

        let res = null;

        try {
            res = await axios.post(dataSettingsUrl, req, { headers: this.headers(okta) });
        } catch (error) {
            console.log(error);
        }

        return res;
    };

    expandField = async (
        reference: string,
        okta: OktaAuth,
        access_token: string,
        instance_url: string,
        org_info?: OrgInfo,
    ) => {
        type ExpandResponse = {
            item_name: string;
            item_fields: { target_name: string; display_name: string; reference_name?: string }[];
        };

        const res = await axios.post<ExpandResponse>(
            `${this.controllerBaseUrl}template/expand?obj_name=${reference}`,
            { access_token, instance_url, org_info },
            { headers: this.headers(okta) },
        );

        const fields: FieldMetadata[] = res.data.item_fields.map((field) => ({
            value: field.target_name,
            displayName: field.display_name,
            getEntriesUrl: field.reference_name,
        }));

        return fields;
    };

    saveMapping = async (mapping: MappingItemProps[], okta: OktaAuth) => {
        const response = await axios.post<void>(`${this.controllerBaseUrl}template/save`, mapping, {
            headers: this.headers(okta),
        });
        return response;
    };
}

export default new DataSettingsApi();
